import { NgModule } from '@angular/core';
import { NoDataMessageModule } from '../components/no-data-message/no-data-message.module';
import { ControlValueToSentenceCaseDirective } from './control-value-to-sentence-case.directive';
import { ControlValueToUpperCaseDirective } from './control-value-to-upper-case.directive';
import { CropTextDirective } from './crop-text.directive';
import { CropToggleLabelDirective } from './crop-toggle-text.directive';
import { DisabledControlDirective } from './disabled-control.directive';
import { FieldCropLabelDirective } from './field-crop-label.directive';
import { HoverHighlightDirective } from './hover-higlight.directive';
import { ImageLoadDirective } from './image-load.directive';
import { InternalNavigationDirective } from './internal-navigate.directive';
import { NoDataTableMessageDirective } from './no-data-table-message.directive';
import { ResizableColumnDirective } from './resize-column-width.directive';
import { ResizeHandleDirective } from './resize-handle.directive';
import { RoundToDirective } from './round-to.directive';
import { SearchSlashDirective } from './search-slash.directive';
import { ShowCheckOrCrossIconDirective } from './show-check-or-cross-icon.directive';
import { ShowWithNoDataMessageDirective } from './show-with-no-data-message.directive';
import { ShowDirective } from './show.directive';
import { VarDirective } from './var.directive';
import { ZoomImagePopupDirective } from './zoom-image-popup.directive';

@NgModule({
  imports: [NoDataMessageModule],
  declarations: [
    ShowDirective,
    SearchSlashDirective,
    CropTextDirective,
    FieldCropLabelDirective,
    NoDataTableMessageDirective,
    ImageLoadDirective,
    VarDirective,
    ZoomImagePopupDirective,
    ControlValueToUpperCaseDirective,
    ShowWithNoDataMessageDirective,
    ShowCheckOrCrossIconDirective,
    DisabledControlDirective,
    CropToggleLabelDirective,
    ControlValueToSentenceCaseDirective,
    InternalNavigationDirective,
    RoundToDirective,
    ResizableColumnDirective,
    ResizeHandleDirective,
    HoverHighlightDirective,
  ],
  exports: [
    ShowDirective,
    SearchSlashDirective,
    CropTextDirective,
    FieldCropLabelDirective,
    NoDataTableMessageDirective,
    ImageLoadDirective,
    VarDirective,
    ZoomImagePopupDirective,
    ControlValueToUpperCaseDirective,
    ShowWithNoDataMessageDirective,
    ShowCheckOrCrossIconDirective,
    DisabledControlDirective,
    CropToggleLabelDirective,
    ControlValueToSentenceCaseDirective,
    InternalNavigationDirective,
    RoundToDirective,
    ResizableColumnDirective,
    ResizeHandleDirective,
    HoverHighlightDirective,
  ],
})
export class DirectivesModule {}
